/**
 * @Description: 通知提示组件
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2022-03-16 09:48:21
 * @LastEditors: 琴时
 * @LastEditTime: 2022-11-24 19:22:45
 */
import Vue from 'vue'
// 封装提示成功的弹出框
Vue.prototype.notifySuccess = function (msg, time = 3000) {
  this.$notify.success({
    title: '成功',
    message: msg,
    offset: 100,
    duration: time,
  })
}
// 封装提示失败的弹出框
Vue.prototype.notifyError = function (msg, time = 3000) {
  this.$notify.error({
    title: '错误',
    message: msg,
    offset: 100,
    duration: time,
  })
}

// 封装提示警告的弹出框
Vue.prototype.notifyWarn = function (msg, time = 3000) {
  this.$notify.warning({
    title: '警告',
    message: msg,
    offset: 100,
    duration: time,
  })
}

// 封装提示警告的弹出框
Vue.prototype.notifyInfo = function (msg, time = 3000) {
  this.$notify.info({
    title: '提示',
    message: msg,
    offset: 100,
    duration: time,
  })
}
